<template>
  <b-container class="decommission-wrapper my-5">
    <b-row>
      <b-col lg="5" class="decommission-pane text-center mb-5">
        <p class="heading">Sale sheets<br/>have moved</p>
        <p class="subheading">Find them and other marketing assets on the SixAxis' marketing portal</p>

        <div class="sixaxis-pane">
          <b-button variant="customgreen" size="lg" href="https://brandfolder.com/sixaxis/">Go to Marketing Portal</b-button>
          <p class="mt-3">Make sure to update your bookmark</p>
        </div>

        <div class="saferack-pane">
          <p class="heading">SafeRack RAMS</p>
          <p>The SafeRack branded ES, YG and RS Sales Sheets can be found under SafeRack</p>
          <b-button variant="orange" size="sm" href="https://brandfolder.com/sixaxis/saferack">Direct Link SafeRack Brand Portal</b-button>
        </div>
      </b-col>
      <b-col class="text-center">
        <img src="images/inset-image.png" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Decommission',
}
</script>